export default __webpack_public_path__ + "static/config/config.31d6cfe0.JSON";